import {
  PerpOrderRecord,
  PerpPositionClearingsRecord,
  PerpPositionRecord,
} from 'api/v1/perp'
import { SpotOrderStatus, TradingFeeRates } from 'api/v1/spot'
import { OrderDirection, OrderModeNames, OrderType } from 'store/spot/types'
import { Ether, SymbolName } from 'types'

export interface PerpState {
  currentPerpSymbol: number
  feeRates: TradingFeeRates | undefined
  openOrders: PerpOrderRecord[]
  badgeOrder: boolean
  badgeTrade: boolean
  positions: PerpPositionRecord[]
  perpCreateOrderOption: PerpCreateOrderOption
  orderMode: OrderModeNames
  perpLastInputAmountType: PerpLastInputAmountType
  perpOrderDirection: OrderDirection
  orderTab: PerpOrderTabType
  cancelPerpPendingIds: number[]
  closePositionSymbols: SymbolName[]
  closePositionOrderIds: number[]
  closedOrders: PerpClosedOrders
  positionClearings: PerpPositionClearingsType
  cancelAllPerpState: boolean
  closeAllPerpState: boolean
  postOnly: boolean
}

// Close position orders data pushed through WebSocket
export interface ClosePositionOrderData {
  symbolId: number
  symbol: string
  quantity: number
  orderId: number
  fee: number
  type: OrderType
  fillPrice: number
  createdAt: number
  unfilledQuantity: number
  price: number
  tradeType: 'SPOTS' | 'CONTRACTS'
  status: SpotOrderStatus
  direction: OrderDirection
}
export interface PerpCreateOrderOption {
  limitPrice: Ether
  stopPrice: Ether
  baseCurrencyAmount: Ether
  quoteCurrencyAmount: Ether
}
export enum PerpLastInputAmountType {
  BaseCurrency,
  QuoteCurrency,
}

export enum PerpOrderTabType {
  Position = 'Position',
  OpenOrder = 'OpenOrder',
  OrderHistory = 'OrderHistory',
  TradeHistory = 'TradeHistory',
}

export interface PerpClosedOrders {
  list: PerpOrderRecord[]
  isLastPage: boolean
  offsetId: number
}
export interface PerpPositionClearingsType {
  list: PerpPositionClearingsRecord[]
  isLastPage: boolean
  offsetId: number
}

export enum PerpOrderTypeFilterEnum {
  All = 'All',
  Limit = 'Limit',
  StopLimit = 'Stop Limit',
  StopMarket = 'Stop Market',
  TakeProfitLimit = 'Take Profit Limit',
  TakeProfitMarket = 'Take Profit Market',
}

export enum PerpOrderDirectionFilterEnum {
  All = '',
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export enum PerpOrderStatusFilterEnum {
  All = '',
  FAILED = 'FAILED', // Order is failed to execute (e.g. market order with no market price).
  FULLY_FILLED = 'FULLY_FILLED', // Limit order is fully filled (filledAmount = amount, do not in order book) or market order is filled.
  PARTIAL_FILLED = 'PARTIAL_FILLED', // Limit order is partially filled (amount > filledAmount > 0) and still in order book as maker.
  PARTIAL_CANCELLED = 'PARTIAL_CANCELLED', // ONLY for limit order / stop limit order: order is partially cancelled and done as final status (amount > filledAmount > 0).
  FULLY_CANCELLED = 'FULLY_CANCELLED',
}
